export const ADVERTISEMENT_VIEWS = ['couple', 'guest'];

export const ADVERTISEMENT_PLACEMENTS = [
  'cashFundGuestPurchaseConfirmation',
  'cashFundCreationLanding',
  'cashFundCreationConfirmation',
  'registryStorePurchaseConfirmation',
];

export const advertisementData = {
  rentTheRunway: {
    company: 'Rent the Runway',
    placementLinks: {
      cashFundGuestPurchaseConfirmation: 'https://renttherunway.pxf.io/QYdVOx',
      cashFundCreationLanding: 'https://renttherunway.pxf.io/qW6rnN',
      cashFundCreationConfirmation: 'https://renttherunway.pxf.io/qW6rnN',
      registryStorePurchaseConfirmation: 'https://renttherunway.pxf.io/QYdVOx',
    },
    imageSource:
      'https://media-api.xogrp.com/images/f1da4388-3205-4278-b2a5-b80030eb6bc9',
    linkText: 'Rent now',
    couple: {
      text: "The perfect 'something borrowed'",
    },
    guest: {
      text: 'Spend Less. Wear More.',
    },
  },
  faye: {
    company: 'Faye',
    placementLinks: {
      cashFundGuestPurchaseConfirmation:
        'https://lp.withfaye.com/theknot//?utm_campaign=cash-fund-guest-purchase-confirmation&utm_medium=null&utm_source=001WV00000TdAjZYAV&utm_term=landingpage',
      cashFundCreationLanding:
        'https://lp.withfaye.com/theknot//?utm_campaign=cash-fund-creation-lp&utm_medium=null&utm_source=001WV00000TdAjZYAV&utm_term=landingpage',
      cashFundCreationConfirmation:
        'https://lp.withfaye.com/theknot//?utm_campaign=cash-fund-creation-cp&utm_medium=null&utm_source=001WV00000TdAjZYAV&utm_term=landingpage',
      registryStorePurchaseConfirmation:
        'https://lp.withfaye.com/theknot//?utm_campaign=registery-store-purchase-confirmation&utm_medium=null&utm_source=001WV00000TdAjZYAV&utm_term=landingpage',
    },
    imageSource:
      'https://media-api.xogrp.com/images/8ea3a0fc-225b-4a5f-b275-7e5208c9db94',
    linkText: 'Get a quote',
    couple: {
      text: 'Protect your honeymoon',
    },
    guest: {
      text: 'Protect your wedding travel',
    },
  },
};

export const ADVERTISEMENT_PARTNERS = Object.keys(advertisementData);
